import React from 'react';
import { useUser } from '@lore/auth';
import { Helmet } from 'react-helmet-async';
import ParentLayout from '../Layout';
import Urls from '../Urls';
import { PayloadStates } from '@lore/utils';
import Loader from '../../../components/Loader';
import Form from './Form';
import useTags from '../../../hooks/useTags';
import TagTypes from '../../../constants/TagTypes';
import useUserTags from '../../../hooks/useUserTags';
import useRouter from '../../../hooks/useRouter';
import useIntents from '../../../hooks/useIntents';
import useSetupNavigation from '../useSetupNavigation';

export default function Layout(props) {
  const { history } = useRouter();
  const user = useUser();

  const navigation = useSetupNavigation(Urls.SKILLS);

  const { isEducator, isPartner } = useIntents();

  const expertiseTypes = useTags(TagTypes.ExpertiseType);
  const userExpertises = useUserTags(user, TagTypes.Expertise);

  if (
    expertiseTypes.state === PayloadStates.FETCHING ||
    userExpertises.state === PayloadStates.FETCHING
  ) {
    return (
      <ParentLayout>
        <Helmet>
          <title>Setup - Skills</title>
        </Helmet>
        <Loader />
      </ParentLayout>
    );
  }

  return (
    <ParentLayout>
      <Helmet>
        <title>Setup - Skills</title>
      </Helmet>
      <Form
        user={user}
        expertiseTypes={expertiseTypes}
        userExpertises={userExpertises}
        navigation={navigation}
        onPrevious={(newData) => history.push(Urls.SKILLS_INTRODUCTION)}
        onNext={() => isPartner && isEducator ? history.push(Urls.EXPERIENCE) : history.push(Urls.ACTIVITY_TYPES)}
        onSkip={() => isPartner && isEducator ? history.push(Urls.EXPERIENCE) : history.push(Urls.ACTIVITY_TYPES)}
      />
    </ParentLayout>
  );
};
